module.exports = __webpack_public_path__ + "946e6bc1f9ae275bdc8ceb6d608243e8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/balloon-purple-heart-right.png
// module id = 2817
// module chunks = 0